import CONST from './constants';
import { UrlUtil, CookieUtil } from '@graffer-inc/graffer-ui';

const params = UrlUtil.parseQueryOf(window.location.search);

// 精度の高いアクセス解析のためにURLにクエリパラメータがあればcookieにsetする
if (params['utm_source'] || params['utm_medium'] || params['utm_campaign']) {
  const utm = {
    source: params['utm_source'],
    medium: params['utm_medium'],
    campaign: params['utm_campaign'],
  };
  // gaのセッションと同様、有効期限を30分にする
  CookieUtil.set(CONST.COOKIE.UTM, JSON.stringify(utm),  60 * 30);
}